document.addEventListener('DOMContentLoaded', function () {
    function animateElementsOnScroll() {
        var elements = document.querySelectorAll('[data-animate]');
        if (!elements.length) return;
    
        elements.forEach(function (element) {
            if (isElementInViewport(element)) {
                applyAnimation(element);
            }
        });
    }
    
    function isElementInViewport(element) {
        var rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
    
    function applyAnimation(element) {
        if (element.classList.contains('animated')) return;
    
        var animationClass = element.getAttribute('data-animate');
        var delay = element.getAttribute('data-animate-delay');
    
        element.classList.add('animated');
        element.classList.add(animationClass);
        element.style.animationDelay = delay + 'ms';
    }
    animateElementsOnScroll();
    window.addEventListener('scroll', animateElementsOnScroll);    
});